import GithubBeatingHeart from "../../../../src/components/GithubBeatingHeart";
import * as React from 'react';
export default {
  GithubBeatingHeart,
  React
};